import { ProductTagPlacement, ThumbnailShapeEnum, WidgetSizeEnum, } from '@core/types';
import { embedFeedRender } from '@embed/embedFeedRender';
import { FWNElement } from './bases/FWNElement';
class GridElement extends FWNElement {
    render() {
        if (this.shadowRoot) {
            embedFeedRender({
                mode: 'grid',
                widgetParams: this.getAttributes(),
                widgetId: this.widgetId,
                target: this.shadowRoot,
            });
        }
    }
}
class CarouselElement extends FWNElement {
    render() {
        if (this.shadowRoot) {
            embedFeedRender({
                mode: 'row',
                widgetParams: this.getAttributes(),
                widgetId: this.widgetId,
                target: this.shadowRoot,
            });
        }
    }
}
class EmbedFeedElement extends FWNElement {
    render() {
        if (this.shadowRoot) {
            embedFeedRender({
                mode: 'row',
                widgetParams: this.getAttributes(),
                widgetId: this.widgetId,
                target: this.shadowRoot,
            });
        }
    }
}
class PlayerDeckElement extends FWNElement {
    render() {
        if (this.shadowRoot) {
            embedFeedRender({
                mode: 'row',
                widgetParams: {
                    ...this.getAttributes(),
                    player_deck_layout: true,
                    captions: false,
                    product_tag_placement: ProductTagPlacement.FALSE,
                },
                widgetId: this.widgetId,
                target: this.shadowRoot,
            });
        }
    }
}
class StoriesElement extends FWNElement {
    render() {
        if (this.shadowRoot) {
            embedFeedRender({
                mode: 'stories',
                widgetParams: {
                    // default to small thumbs
                    size: WidgetSizeEnum.SMALL,
                    thumbnail_shape: ThumbnailShapeEnum.CIRCLE,
                    ...this.getAttributes(),
                    captions: false,
                    product_tag_placement: ProductTagPlacement.FALSE,
                },
                widgetId: this.widgetId,
                target: this.shadowRoot,
            });
        }
    }
}
const elements = new Map([
    ['fw-embed-feed', EmbedFeedElement],
    ['fw-carousel', CarouselElement],
    ['fw-grid', GridElement],
    ['fw-player-deck', PlayerDeckElement],
    ['fw-stories', StoriesElement],
]);
elements.forEach((elementClass, elementName) => {
    if (!customElements.get(elementName)) {
        customElements.define(elementName, elementClass);
    }
});
